import { LoadSliderInputRanges, LoadSliderInputValues, Tags } from '../models';

export const INITIAL_LOAD_VALUES: LoadSliderInputValues = {
    n0: null,
    n1: null,
    n2: null,
    n3: null,
    n4: null,
    m0: null,
    m1: null,
    m2: null,
    m3: null,
    m4: null
};

export const INITIAL_LOAD_RANGES: LoadSliderInputRanges = {
    n0: null,
    n1: null,
    n2: null,
    n3: null,
    n4: null,
    m0: null,
    m1: null,
    m2: null,
    m3: null,
    m4: null
};

export const INITIAL_LOAD_TAG_VALUES: Partial<Tags> = {
    n0: undefined,
    n1: undefined,
    n2: undefined,
    n3: undefined,
    n4: undefined,
    m0: undefined,
    m1: undefined,
    m2: undefined,
    m3: undefined,
    m4: undefined
};
